import { css } from "@emotion/react"
import { ICONS } from "src/modules/ui-elements/Icon"
import ResizePill from "src/modules/ui-elements/ResizePill"

export const STANDARD_SIZES = [
    {
        icon: ICONS.bell,
        name: "Landscape",
        height: 2560,
        width: 1440,
    },
    {
        icon: ICONS.bell,
        name: "Portrait",
        height: 1440,
        width: 2560,
    },
    {
        icon: ICONS.bell,
        name: "Square",
        height: 1512,
        width: 1512,
    },
]

export const SOCIAL_MEDIA_SIZES = [
    {
        icon: "/icons/marketplace-icons/instagram-story.png",
        name: "Instagram Story",
        height: 1920,
        width: 1080,
    },
    {
        icon: "/icons/marketplace-icons/instagram.png",
        name: "Instagram Post",
        height: 1080,
        width: 1080,
    },
    {
        icon: "/icons/marketplace-icons/facebook.png",
        name: "Facebook Story",
        height: 1920,
        width: 1080,
    },
    {
        icon: "/icons/marketplace-icons/pintrest.png",
        name: "Pinterest Story",
        height: 1920,
        width: 1080,
    },
]

export default function SizesList({title,list,containerStyle={}, containerCSS=css``, onResizeGenerator=(item)=>()=>{}, disabled=false, activeSize={}}) {
    return <div css={ css`${containerCSS}`} style={{...containerStyle}}> 
        <div css={styles.titleContainer}>{title}</div>
        {list && list?.map(size=>(
            <ResizePill icon={size.icon} isGroupLogo={size?.isGroupLogo}  name={size.name} height={size.height} width={size.width} onClick={onResizeGenerator(size)} disabled={disabled} active={(activeSize?.width === size?.width && activeSize.height === size?.height && activeSize?.name === size.name)} />
        ))}
        {!list && Array(4).fill(0).map(_=><ResizePill loading={true} />)}
        <div css={styles.divider}></div>
    </div>
}

const styles = {
    titleContainer: css`
        color: #262626;
        font-family: Objectivity;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 170%; 
        margin-left:10px;
        margin-right:10px;
    `,
    divider: css`
        width: 100%;
        height: 0.5px;
        background: #EEE;
        margin-top:8px;
        margin-bottom:8px;
    `
}